define('fontmanager',['require','exports','module','underscore','fonts/fonts'],function(require, exports, module) {
  "use strict";

  var _ = require("underscore"),
      fonts = require("fonts/fonts");

  function getNames() {
    return _.union(_.keys(fonts.system), _.keys(fonts.google));
  }

  function getLinks() {
    return _.values(fonts.google);
  }

  function getCustomFontsLink() {
    var link = "https://fonts.googleapis.com/css?family=",
        fonts = getLinks().join("|");
    return link + fonts;
  }

  return {
    getNames: getNames,
    getCustomFontsLink: getCustomFontsLink
  };
});

